import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { OffTransfer } from 'modules/warehouse';
import useAddProductsTransfer, {
    type AddProductsSourceKey,
} from './model/useAddProductsTransfer';
import SolarIcon from 'components/icons/SolarIcon';

const SOURCE_META: Record<
    AddProductsSourceKey,
    { titleKey: string; hintKey: string; icon: string }
> = {
    reserve: {
        titleKey: 'addProducts.fromReserve',
        hintKey: 'addProducts.fromReserveHint',
        icon: 'bi-bookmark-star',
    },
    team: {
        titleKey: 'addProducts.fromTeam',
        hintKey: 'addProducts.fromTeamHint',
        icon: 'bi-people',
    },
    main: {
        titleKey: 'addProducts.fromMain',
        hintKey: 'addProducts.fromMainHint',
        icon: 'bi-building',
    },
};

const AddProductsDropdown = () => {
    const { t } = useTranslation(['Objects']);
    const {
        canAdd,
        sources,
        teamName,
        objectWarehouseId,
        showTransfer,
        setShowTransfer,
        sourceWId,
        sourceReservObjectId,
        openTransfer,
        handleFetchStocks,
    } = useAddProductsTransfer();

    if (!canAdd) return null;

    const hintFor = (key: AddProductsSourceKey) => {
        if (key === 'team') {
            const team = teamName
                ? t('addProducts.fromTeamName', { name: teamName })
                : '';
            return t('addProducts.fromTeamHint', { team });
        }
        return t(SOURCE_META[key].hintKey);
    };

    return (
        <>
            {sourceWId > 0 && (
                <OffTransfer
                    wId={sourceWId}
                    teamId={null}
                    reservObjectId={sourceReservObjectId}
                    fixedToWarehouseId={objectWarehouseId}
                    fetchStocks={handleFetchStocks}
                    show={showTransfer}
                    setShow={setShowTransfer}
                />
            )}

            <div className="text-center w-100 mt-4">
                <Dropdown>
                    <Dropdown.Toggle className="py-2" size="sm" variant="primary">
                        <SolarIcon name="box-seam" className="me-2" />
                        {t('addProducts.btnAdd')}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="p-2 shadow-sm warehouse-team-menu text-start">
                        {sources.map((source) => {
                            const meta = SOURCE_META[source.key];
                            return (
                                <Dropdown.Item
                                    key={source.key}
                                    as="button"
                                    onClick={(e) => {
                                        openTransfer(source.key);
                                        e.currentTarget.blur();
                                    }}
                                >
                                    <div className="d-flex align-items-start w-100 text-start">
                                        <span className="d-inline-flex align-items-center justify-content-center flex-shrink-0 me-2 item-icon">
                                            <SolarIcon name={meta.icon} />
                                        </span>
                                        <div className="flex-grow-1 min-w-0">
                                            <div className="fw-medium">{t(meta.titleKey)}</div>
                                            <small className="text-muted warehouse-team-menu-hint">
                                                {hintFor(source.key)}
                                            </small>
                                        </div>
                                    </div>
                                </Dropdown.Item>
                            );
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </>
    );
};

export default AddProductsDropdown;
